import React, { useState } from 'react';
import {
  Box,
  Grid,
  Paper,
  CardActionArea,
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

export const LIGHT_COLOR_LIST = [
  '#FFECB3', // Light Amber
  '#B2EBF2', // Aqua
  '#F8BBD0', // Light Pink
  '#C8E6C9', // Light Green
  '#D1C4E9', // Soft Purple
  '#FFF9C4', // Pale Yellow
  '#B2DFDB', // Mint
  '#FFCCBC', // Peach
  '#C5CAE9', // Soft Indigo
  '#F0F4C3', // Citron
  '#BBDEFB', // Baby Blue
  '#F3E5F5', // Light Lilac
  '#E6EE9C', // Mild Lime
  '#E1BEE7', // Lavender
  '#FFE0B2', // Light Orange
  '#DCEDC8', // Pale Lime
  '#FFCDD2', // Light Red
  '#E0F7FA', // Light Cyan
  '#D7CCC8', // Warm Grey
  '#F5F5F5', // Off White
]

export const DARK_COLOR_LIST = [
  "#8E44AD", // Dark Purple
  "#28B463", // Dark Green
  "#CA6F1E", // Dark Orange
  "#1ABC9C", // Dark Turquoise
  "#D4AC0D", // Dark Yellow
  "#2E86C1", // Dark Blue
  "#239B56", // Dark Mint
  "#A569BD", // Dark Lavender
  "#2874A6", // Dark Sky Blue
  "#B9770E", // Dark Amber
  "#138D75", // Dark Teal
  "#CB4335", // Dark Red
  "#1F618D", // Dark Cobalt
  "#7D6608", // Dark Olive
  "#117A65", // Dark Jade
  "#E67E22", // Dark Coral
  "#6C3483", // Dark Plum
  "#229954", // Dark Emerald
  "#616A6B", // Dark Gray
  "#B7950B", // Dark Gold
]

export default function ColorPicker({
  handleColorChange,
  color_shade="light",
  defaultColor='#FFFFFF',
}) {
  const [selectedColor, setSelectedColor] = useState(defaultColor);

  const handleColorSelect = (color) => {
    setSelectedColor(color);
    handleColorChange(color);
  };

  // Helper function to determine if a color is light or dark
  const isLightColor = (hexColor) => {
    // Convert hex to RGB
    const r = parseInt(hexColor.slice(1, 3), 16);
    const g = parseInt(hexColor.slice(3, 5), 16);
    const b = parseInt(hexColor.slice(5, 7), 16);
    
    // Calculate luminance (perceived brightness)
    // Formula: (0.299*R + 0.587*G + 0.114*B)
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    
    // If luminance is greater than 0.5, color is light
    return luminance > 0.7;
  };

  return (
    <Paper elevation={3} sx={{ p: 1, minWidth: 150, maxWidth: 180, mx: 'auto', boxShadow: 0 }}>
      {/* Color Grid */}
      <Grid container spacing={{ xs: 0.25, sm: 0.5 }}>
        {(color_shade === "light" ? LIGHT_COLOR_LIST : DARK_COLOR_LIST).map((color) => (
          <Grid item xs={2.4} key={color}>
            {/* <Tooltip title={`${color.name}`} arrow> */}
              <CardActionArea 
                onClick={() => handleColorSelect(color)}
                sx={{
                  aspectRatio: '1/1',
                  bgcolor: color,
                  borderRadius: '50%',
                  border: '1px solid rgba(0,0,0,0.12)',
                  transition: 'transform 0.2s',
                  position: 'relative', 
                  '&:hover': {
                    transform: 'scale(1.05)'
                  }
                }}
              >
                {selectedColor === color && (
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 0,
                      right: 0,
                      bottom: 0,
                      left: 0,
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: 'rgba(0,0,0,0.1)'
                    }}
                  >
                    <CheckIcon sx={{ 
                      color: isLightColor(color) ? '#222' : '#fff',
                      fontSize: 18 
                    }} />
                  </Box>
                )}
              </CardActionArea>
            {/* </Tooltip> */}
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
}
